<template>
  <div class="discovery-account-table-cell">
    <span class="body1"> <i :class="icon"></i> </span>
    <span class="body2">{{ discoveryKey }}</span>
  </div>
</template>

<script>
export default {
  name: 'DiscoverySourceTableCell',
  props: {
    icon: {
      type: [String]
    },
    discoveryKey: {
      type: [String, Number]
    }
  },
  data () {
    return {}
  },
  mounted () {},
  computed: {}
}
</script>

<style scoped>
@import 'assets/styles/tables.css';
.discovery-account-table-cell{
  text-align: center;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/table/cell/DiscoverySourceTableCell.vue